import React from 'react'
import { useHistory } from "react-router-dom";
const SparePartSeller = (props) => {
    const history = useHistory();
    let state = history && history.location && history.location.state;
    const handleRedirect = (e) => {
      e && e.preventDefault();
      props.handleLogging(e, { ChildMenuRedirectURL: process.env.REACT_APP_SPAREPARTLOCATION_ROUTE, ChildMenuName: "Spare Part Seller" }, 1, 'Onload Spare Part Seller')
      history.push(process.env.REACT_APP_SPAREPARTLOCATION_ROUTE, state);
      props.handleScroll()
    }
  return (
    <div className='home-video-section  mb-5 mt-0 pb-0'>
    <div className='main-container'>
        <div className='row'>
            <div className='col-sm-12 '>
                <div className="sellerSection">
                    <div className='row align-items-center'>
                        <div className='col-md-6 pl-md-5 text-left mb-md-0 mb-3'>
                            <h2 className='form__title mb-0 mb-mt-5 mb-2 mt-md-0 text-left' data-font-size-mo="16" data-font-size-pc="48">Authorized Spare Part Seller</h2>
                            <p data-font-size-mo="12" data-font-size-pc="16" className='mb-md-0 pb-md-0'>Genuine Samsung Spare Part, Reliable Repairs</p>
                        </div>
                        <div className='col-md-6 text-right'>
                            <a class="cta cta--contained cta--white cta--icon ml-2" href="" onClick={handleRedirect}>Explore Now</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
  )
}

export default SparePartSeller